import styled from 'styled-components'

const ProductsContentWrapper = styled.div`
  overflow-y: auto;
  position: relative;
`

const ImageWrapper = styled.div`
  width: 100%;
`

export { ProductsContentWrapper, ImageWrapper }
